import { useLocation } from 'react-router-dom';

interface LocationState {
  from?: { pathname?: string; search?: string };
}

/**
 * Reads the `from` state planted by `ProtectedRoute` and reconstructs the
 * original URL (pathname + search) the user was trying to reach. Used by the
 * Login and Register pages to bounce the user back after sign-in.
 *
 * Returns `'/'` when there's no `from` state.
 */
export function useRedirectTarget(): string {
  const location = useLocation();
  const from = (location.state as LocationState | null)?.from;
  if (!from?.pathname) return '/';
  return `${from.pathname}${from.search ?? ''}`;
}
